import { useContext } from 'react';
import { AuthContext } from '../Auth/Auth';

const useAuth = () => useContext(AuthContext);

export default useAuth;
